<template>
    <section :class="'page-section section-content-with-photo ' ">
        <div class="container-fluid">

            <div class="block-wrapper">
                <div class="image-wrapper">
                    <img :src="contentPhoto_image" alt="">
                </div>

                <div class="content-wrapper" style="text-align: left;">
                    <h2>
                        <div v-safe-html="contentPhoto_title" style="font-size: 22px;"/>
                    </h2>
                    <div v-safe-html="contentPhoto_content1"  style="font-size: 20px;"/>
                    <div v-safe-html="contentPhoto_content2" />
                </div>
            </div>

        </div>
    </section>
</template>
  
<script>
export default {
    props: {
    contentPhoto_image: String,
    contentPhoto_title: String,
    contentPhoto_content1: String,
    contentPhoto_content2: String,

  },
    data() {
        return {

            image: require('@/assets/404.jpg'),
        };
    }
};
</script>
  
<style>
@import '@/css/contentWithPhotoSection.css';

.page-section.section-content-with-photo {
   display: flex;
   justify-content:space-between;
  }

/* Readability for longer titles/content:
   the global h2 sets line-height:16px which makes the 22px title overlap
   when it wraps to multiple lines. Restore a proportional line-height and
   let long words/URLs wrap instead of overflowing. */
.page-section.section-content-with-photo .content-wrapper h2,
.page-section.section-content-with-photo .content-wrapper h2 > div {
  line-height: 1.35;
}

.page-section.section-content-with-photo .content-wrapper {
  overflow-wrap: break-word;
  word-break: break-word;
}

.page-section.section-content-with-photo .content-wrapper > div {
  line-height: 1.6;
}
</style>